export default __webpack_public_path__ + "static/google-cloud-partner-cb857206d6685716b31fc6f7e5d2a7eb.png";